import { render, staticRenderFns } from "./OrganizationRelationButton.vue?vue&type=template&id=96ec116e&scoped=true"
import script from "./OrganizationRelationButton.vue?vue&type=script&lang=js"
export * from "./OrganizationRelationButton.vue?vue&type=script&lang=js"
import style0 from "./OrganizationRelationButton.vue?vue&type=style&index=0&id=96ec116e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ec116e",
  null
  
)

export default component.exports